import styled, {keyframes} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {font, colors} from 'theme';

export const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ${font.family.primary};
    font-size: 12px;
`;

export const CancelButton = styled(Button)`
    width: 120px;
`;

export const ListWrapper = styled.ul`
    display: flex;
    gap: 20px;
    flex-direction: column;
    width: 100%;
    padding: 0;
`;

export const CertsWrapper = styled.ul`
    display: flex;
    gap: 20px;
    flex-direction: column;
    width: 100%;
    padding: 0;
`;

export const ControlsWrapper = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: flex-end;

    & > * {
        &:first-child {
            margin-right: auto;
        }

        max-width: 120px;
    }
`;

export const List = styled.ul`
    width: 100%;
    padding: 0;
`;

export const ListItem = styled.li<{selected: boolean}>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 5px;
    font-size: 14px;
    transition: all 0.1s ease-in-out;
    background: ${(p) => p.selected && colors.brandPrimary};
    color: ${(p) => p.selected && colors.white};
    cursor: pointer;
    list-style-type: none;

    & span {
        font-weight: bold;
    }

    &:hover {
        background: ${colors.brandPrimary};
        color: ${colors.white};
    }
`;

export const CheckResult = styled.div<{original: boolean}>`
    width: 370px;
    max-width: 100%;
    padding: 12px;
    color: ${colors.white};
    background-color: ${(p) => (p.original ? '#65C686' : '#F96969')};
    text-align: center;
    border-radius: 4px;
    margin-bottom: 30px;
`;

export const LoadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    font-family: ${font.family.primary};
    font-size: 14px;
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 80px;

    animation: ${opacity} 2s ease;
`;
